import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, TerminalIcon } from 'lucide-react';
const navLinks = [{
  href: '#home',
  label: 'Home'
}, {
  href: '#about',
  label: 'About'
}, {
  href: '#experience',
  label: 'Experience'
}, {
  href: '#education',
  label: 'Education'
}, {
  href: '#projects',
  label: 'Projects'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = () => {
    setIsOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-950/90 backdrop-blur-md border-b border-slate-800' : 'bg-transparent'}`} role="navigation" aria-label="Main navigation" data-id="element-251">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
        <div className="flex items-center justify-between h-16" data-id="element-253">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-2 text-emerald-400 hover:text-emerald-300 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 rounded-md" aria-label="Go to home" data-id="element-254">
            <TerminalIcon className="w-6 h-6" aria-hidden="true" data-id="element-255" />
            <span className="font-mono font-semibold text-lg" data-id="element-256">peter.dev</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1" data-id="element-257">
            {navLinks.map(link => <a key={link.href} href={link.href} className="px-4 py-2 text-sm text-slate-300 hover:text-emerald-400 transition-colors rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950" data-id="element-258">
                {link.label}
              </a>)}
          </div>

          {/* Mobile Menu Button */}
          <button type="button" onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-slate-300 hover:text-emerald-400 transition-colors rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950" aria-expanded={isOpen} aria-controls="mobile-menu" aria-label={isOpen ? 'Close menu' : 'Open menu'} data-id="element-259">
            {isOpen ? <XIcon className="w-6 h-6" aria-hidden="true" data-id="element-260" /> : <MenuIcon className="w-6 h-6" aria-hidden="true" data-id="element-261" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-262">
        {isOpen && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-slate-900/95 backdrop-blur-md border-b border-slate-800 overflow-hidden" data-id="element-263">
            <div className="px-4 py-4 space-y-1" data-id="element-264">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={handleNavClick} className="block px-4 py-3 text-slate-300 hover:text-emerald-400 hover:bg-slate-800/50 rounded-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400" data-id="element-265">
                  {link.label}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}